import { render } from "./TableQuestion.vue?vue&type=template&id=fe8616dc&scoped=true"
import script from "./TableQuestion.vue?vue&type=script&lang=js"
export * from "./TableQuestion.vue?vue&type=script&lang=js"

import "./TableQuestion.vue?vue&type=style&index=0&id=fe8616dc&lang=scss&scoped=true"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe8616dc"]])

export default __exports__